"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManufacturerFeedDto = void 0;
const ManufacturerDto_1 = require("../manufacturers/ManufacturerDto");
class ManufacturerFeedDto {
    constructor(params) {
        this.site = "";
        this.url = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.manufacturerId = params.manufacturerId;
        this.site = params.site;
        this.url = params.url;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.manufacturer !== undefined) {
            this.manufacturer = params.manufacturer === null ?
                null :
                new ManufacturerDto_1.ManufacturerDto(params.manufacturer);
        }
    }
}
exports.ManufacturerFeedDto = ManufacturerFeedDto;
//# sourceMappingURL=ManufacturerFeedDto.js.map